export default __webpack_public_path__ + "static/media/Read4Fun-ios.8c337ee3.png";